import WebTermsOfUse from './WebTermsOfUse';

export default WebTermsOfUse;
